// extracted by mini-css-extract-plugin
export default {"todoEditor":"TodoEditor_todoEditor__gmIvf","todoEditor__textarea":"TodoEditor_todoEditor__textarea__MgVFv","todoEditor__button":"TodoEditor_todoEditor__button__4NcgJ"};